"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var ReactDOM = require("react-dom");
var index_1 = require("../src/ontodia/index");
var exampleMetadataApi_1 = require("./resources/exampleMetadataApi");
var common_1 = require("./common");
var N3Parser = require('rdf-parser-n3');
var RdfXmlParser = require('rdf-parser-rdfxml');
var JsonLdParser = require('rdf-parser-jsonld');
var data = require('./resources/orgOntology.ttl');
function onWorkspaceMounted(workspace) {
    if (!workspace) {
        return;
    }
    var dataProvider = new index_1.RDFDataProvider({
        data: [
            {
                content: data,
                type: 'text/turtle',
                fileName: 'testData.ttl',
            },
        ],
        acceptBlankNodes: false,
        dataFetching: false,
        parsers: {
            'application/rdf+xml': new RdfXmlParser(),
            'application/ld+json': new JsonLdParser(),
            'text/turtle': new N3Parser(),
        },
    });
    var diagram = common_1.tryLoadLayoutFromLocalStorage();
    workspace.getModel().importLayout({
        diagram: diagram,
        validateLinks: true,
        dataProvider: dataProvider,
    });
}
var props = {
    ref: onWorkspaceMounted,
    onSaveDiagram: function (workspace) {
        var diagram = workspace.getModel().exportLayout();
        window.location.hash = common_1.saveLayoutToLocalStorage(diagram);
        window.location.reload();
    },
    onPersistChanges: function (workspace) {
        var state = workspace.getEditor().authoringState;
        // tslint:disable-next-line:no-console
        console.log('Authoring state:', state);
    },
    metadataApi: new exampleMetadataApi_1.ExampleMetadataApi(),
    validationApi: new exampleMetadataApi_1.ExampleValidationApi(),
    viewOptions: {
        onIriClick: function (_a) {
            var iri = _a.iri;
            return window.open(iri);
        },
        groupBy: [
            { linkType: 'http://www.w3.org/1999/02/22-rdf-syntax-ns#type', linkDirection: 'in' },
        ],
    },
    elementTemplateResolver: function (types) {
        if (types.length === 0) {
            // use group template only for classes
            return index_1.GroupTemplate;
        }
        return undefined;
    },
};
common_1.onPageLoad(function (container) { return ReactDOM.render(react_1.createElement(index_1.Workspace, props), container); });
